import {
  GET_LIVE_AUCTIONS,
  GET_RECENT_DEALS,
  GET_WORTHY_STATS,
} from '../actions/homepage';

export default (state = null, action) => {
  const {payload} = action;

  switch (action.type) {
    case GET_WORTHY_STATS:
      return Object.assign({}, state, {stat: payload.data});
    case GET_LIVE_AUCTIONS:
      return Object.assign( {}, state, {liveAuctions: payload});
    case GET_RECENT_DEALS:
      return Object.assign( {}, state, {recentDeals:payload})
  }

  return state;
}